// Rounds a retailer price the way the API bills it: ItemsService.Get (RingBuilderAPI) computes
// Math.Round((retailerPrice + engravingFee) / 5) * 5, and C#'s Math.Round(double) rounds an exact
// midpoint to the EVEN neighbour. JS Math.round rounds it up, so it cannot be used here — a raw
// $1,002.50 is billed at $1,000, not $1,005. (ADO #10114)
export function roundRetailerPrice(price: number): number {
  return roundHalfToEven(price / 5) * 5;
}

function roundHalfToEven(value: number): number {
  if (Math.abs(value % 1) === 0.5) {
    return 2 * Math.round(value / 2);
  }
  return Math.round(value);
}
